export const apiConstants = {
  CompareFlexibleProducts: 'Calculator/CompareFlexibleProducts',
};
